var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassesAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99781 5.66891C5.06314 5.49804 5.28667 5.45055 5.41823 5.57959L6.34106 6.48474C6.64076 6.77871 7.12668 6.77871 7.42639 6.48474C7.72609 6.19078 7.72609 5.71417 7.42639 5.42021L6.50355 4.51505C5.58265 3.61179 4.01794 3.94422 3.56066 5.1403L1.04887 11.7101C0.960488 11.9413 0.993296 12.2002 1.13667 12.4032C1.28004 12.6061 1.51574 12.7272 1.76745 12.7272V17.9963C1.76745 18.5506 2.22557 19 2.7907 19H8.95365C9.4561 19 9.88421 18.6422 9.96394 18.1556L10.8534 12.7272H13.1466L14.0361 18.1556C14.1158 18.6422 14.5439 19 15.0464 19H21.2093C21.7744 19 22.2326 18.5506 22.2326 17.9963V12.7272C22.4843 12.7272 22.72 12.6061 22.8633 12.4032C23.0067 12.2002 23.0395 11.9413 22.9511 11.7101L20.4393 5.1403C19.9821 3.94422 18.4174 3.61179 17.4964 4.51505L16.5736 5.42021C16.2739 5.71417 16.2739 6.19078 16.5736 6.48474C16.8733 6.77871 17.3592 6.77871 17.6589 6.48474L18.5818 5.57959C18.7133 5.45055 18.9369 5.49804 19.0022 5.66891L21.1251 11.2217H2.87486L4.99781 5.66891Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassesAlt1);
export default __webpack_public_path__ + "static/media/glasses-alt-1.fd6e6a7507871fe5e7dabc2fc7b5577a.svg";
export { ForwardRef as ReactComponent };